<template>
  <div>
    <div class="student-list" v-if="showType == 'list'">
      <ul class="student-ul" v-if="studentListCard.length > 0">
        <!-- <virtual-list :style="{height: listHeight + 'px', overflowY: 'auto'}"
          :data-key="'user_id'"
          :data-sources="studentListCard"
          :min-item-size="54"
          :data-component="studentItemComponent"
          :extra-props="{
            showType: showType,
            studentListCard: studentListCard,
            setMessageDisposeStatus: setMessageDisposeStatus,
            viewStudentDetail: viewStudentDetail,
            handleStudent: handleStudent,
            closeCard: closeCard
          }"
          :keeps="keeps1"
          >
        </virtual-list> -->
        <div v-for="(item,index) in studentListCard" :key="item.user_id">
          <studentItem :showType="showType"
            :studentListCard="studentListCard"
            :index="index"
            :source="item"
            :dataNum="item.data?item.data.length:0"
            :setMessageDisposeStatus="setMessageDisposeStatus"
            :viewStudentDetail="viewStudentDetail"
            :handleStudent="handleStudent"
            @closeCard="closeCard"/>
        </div>

      </ul>
      <div class="no-people" v-else>
        <i class="icon-shafa"></i>
        <p class="text">{{isAgent ? `${$t('studentList.allStudent.631798-0')}` : `${$t('studentList.allStudent.631798-1')}`}}</p>
      </div>
    </div>
    <div class="left-list" v-else-if="showType == 'leftList'">
      <div class="module-header-title sub" >
        <span class="color-block 1111"></span>
        <template v-if="!isAgent">
          <span v-if="!isCloseLeft && typeof(nowOnlineStudent.count) != 'undefined'">{{ $t('studentList.allStudent.631798-2') }}{{nowOnlineStudent.count}}{{ $t('studentList.allStudent.631798-3') }}</span>
          <span v-else-if="isCloseLeft && typeof(nowOnlineStudent.count) != 'undefined'">{{ $t('studentList.allStudent.631798-4') }}{{nowOnlineStudent.count}}{{ $t('studentList.allStudent.631798-3') }}</span>
        </template>
        <template v-else>
          <span v-if="!isCloseLeft && typeof(nowOnlineStudent.count) != 'undefined'">{{ $t('studentList.allStudent.631798-5') }}{{nowOnlineStudent.count}}{{ $t('studentList.allStudent.631798-3') }}</span>
        </template>
      </div>
      <ul class="student-list left-student-list ttt">
        <div v-for="(item,index) in studentListCard" :key="item.user_id">
          <leftStudentItem :showType="showType"
            :studentListCard="studentListCard"
            :index="index"
            :source="item"
            :dataNum="item.data?item.data.length:0"
            :setMessageDisposeStatus="setMessageDisposeStatus"
            :viewStudentDetail="viewStudentDetail"
            :handleStudent="handleStudent"
            @closeCard="closeCard"/>
        </div>
      </ul>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import List from '@/views/studentList/list';
  import Card from '@/views/studentList/card';
  import VirtualList from "vue-virtual-scroll-list";
  import studentItem from "./studentItem";
  import leftStudentItem from './leftStudentItem.vue';
  import Bus from '@/utils/bus.js'
  import getMsgContorl from '@/utils/getMsgContorl.js'
  import i18n from '@/i18n'
  import { getMultiInfo,getMultiInfoBatch, setStudentStatus, addSuperintendLog,getSubjectiveQuestionList, userStatInfo, getUserInfo, getAuthUserCount } from '@/api/base';
  export default {
    name: "allStudent",
    data() {
      return {
        centerDialogVisible: false,
        activePan: '0',
        // 检测是否第一次登陆
        checkFlag: false,
        onlineStudentStatus: false,
        offLineStatus: false,
        showOp: false,
        checkOnlineListCount:1,
        isFirst: false,
        studentListPan: [{
          'event': 'LOGIN',
          'role': 'STUDENT',
          'user_id': '0',
          'tuid': i18n.t('studentList.allStudent.631798-6'), // 1.8版本新加
          'subject_id': i18n.t('studentList.allStudent.631798-7'), // 1.8版本新加
          'school_id': i18n.t('studentList.allStudent.631798-8'), // 1.8版本新加
          'cid': i18n.t('studentList.allStudent.631798-9'),
          'sid': i18n.t('studentList.allStudent.631798-10'),
          'tid': i18n.t('studentList.allStudent.631798-11'),
          'flow_id': i18n.t('studentList.allStudent.631798-12'),
          'nick': i18n.t('studentList.allStudent.631798-13'),
          'real_sname': i18n.t('studentList.allStudent.631798-13'),
          'app_type': i18n.t('studentList.allStudent.631798-14'), // 可以依据学校ID来区分线上或是线下
          'client_ip': i18n.t('studentList.allStudent.631798-15'),
          'index': 10
        }],
        videotype: '',
        studentList: [],
        studentListCard: [],
        // 上线学生
        onlineStudentList: [],
        msgBusList: [],
        messageList: [],
        userList: [],
        messageLimitList: ['WARN_WRONG_ANSWER', 'WARN_ANSWER_HESITATE', 'WARN_VIDEO_END_DAZE', 'WARN_VIDEO_PAUSE_DAZE', 'WARN_VIDEO_PLAYED_SKIP', 'WARN_VIDEO_UNPLAYED_SKIP', 'LOGIN', 'RELOGIN', 'WARN_ANSWER_TOO_FAST', 'WARN_ANSWER_TOO_SLOW'],
        alarmLimitList: ['WARN_WRONG_ANSWER', 'WARN_ANSWER_HESITATE', 'WARN_VIDEO_END_DAZE', 'WARN_VIDEO_PLAYED_SKIP', 'WARN_VIDEO_UNPLAYED_SKIP', 'WARN_ANSWER_TOO_FAST', 'WARN_ANSWER_TOO_SLOW'],
        // 历史记录
        user_id: 0,
        school_id: 0,
        subject_id: 0,
        flow_id: 0,
        cacheFlag: false,
        cacheEventFlag: false,
        destroyRoomObj:{},
        user_type: 4,
        roleObject: {
          '1':'STUDENT',
          '2':'PARENT',
          '3':'HEADMASTER',
          '4':'TEACHER',
          '5':'OPERATOR',
          '6':'CC',
          '7':'ASSISTANT'
        },
        investFlag: false, // 是否是手动邀请学生
        logOutTimeOutArr: {}, // 学生退出的定时器
        offLineTime: 60, // 下线时间
        systemTimer: null,
        studentItemComponent: studentItem,
        leftStudentItemComponent: leftStudentItem,
        nowOnlineStudent: {},
        isAgent: false, // 是否是代理商
        authUserCount: '', // 授权数量
        colors: ['#B7A1FF', '#90DF89', '#E2BC00', '#69DAD8', '#79ACFF', '#459CD7', '#5B78D8', '#A780D8'],
        listHeight: 560,
        listKeep: 9,
        leftWrapHeight: 630,
        keeps1:0,
        keeps2:0,
      }
    },
    props: ['showType'],
    computed: {
      ...mapGetters([
        'isShowJieRu',
        'pageStudentCard',
        'initWaitQuestionsList',
        'currentViewStudent',
        'systemTime',
        'isCloseLeft'
      ]),
    },
    components: {List, Card, VirtualList,studentItem,leftStudentItem },
    created() {
      let pageHeight = document.body.clientHeight;
      // let sectionHeight = pageHeight - 48 - 62 - 24 - 16;
      // this.listHeight = sectionHeight;
      // this.listKeep = Math.floor(sectionHeight / 130);
      //if (pageHeight < 900) {
        //this.listHeight = 560;
        //this.leftWrapHeight = 560;
      //} else if (pageHeight >= 900 && pageHeight < 1000) {
        //this.listHeight = 560;
        //this.leftWrapHeight = 630;
      //} else {
        //this.listHeight = 1000;
        //this.leftWrapHeight = 630;
      //}
      this.listHeight = pageHeight - 140;
      this.leftWrapHeight = pageHeight - 90;
      Bus.$on('viewFirstStudent', (isLeft) => {
      if (this.studentListCard.length > 0) {
        let newStudentArr = this.sortStudentData(this.studentListCard);
        let firstStudent = newStudentArr[0];
        this.$store.commit('SET_CURRENT_USER_ID', firstStudent['user_id']);
        console.log('viewStudentDetail0099')
        this.viewStudent(firstStudent, 0, isLeft);
      }
    })
    },
    destroyed: function() {
      if(this.threeSecondTimer){
        clearTimeout(this.threeSecondTimer)
      }
    },
    mounted: function() {
      console.log('allStudent mounted')
      getMsgContorl.init(this)
      let teacherInfo = JSON.parse(sessionStorage.getItem('TEACHER_INFO'));
      if (teacherInfo.is_agent_school) {
        this.isAgent = teacherInfo.is_agent_school;
      }
      const vm = this
      this.school_id = sessionStorage.getItem('school_id')
      this.user_type = sessionStorage.getItem('user_type')
      this.checkOnlineList()
      //无数据重复请求
      const startTimeout = (time)=>{
        this.repeatTimer && clearTimeout(this.repeatTimer)
        this.repeatTimer = setTimeout(()=>{
          console.log(!vm.studentList.length, vm.checkOnlineListCount)
          if(!vm.studentList.length && vm.checkOnlineListCount < 4){
            vm.checkOnlineListCount += 1
            this.checkOnlineList(true)
            startTimeout(vm.checkOnlineListCount)
          }else{
            this.repeatTimer && clearTimeout(this.repeatTimer)
          }
        },time * 1000)
      }
      startTimeout(vm.checkOnlineListCount)
      $_chat.onMessage(async function(msg) {
        console.log(msg,msg.user_id,'msg',77777777,vm.currentViewStudent)
        const event = msg.event
        //if (event === 'CHECK_ONLINE_LIST' && !vm.checkFlag) {
        if (event === 'CHECK_ONLINE_LIST' && !vm.studentList.length && !vm.investFlag) {
          //console.log('vm.msgBusList----'+JSON.stringify(vm.msgBusList))
          const suidsOnlineDetail = msg.user_ids_online_detail
          sessionStorage.setItem('suidsOnlineDetail', JSON.stringify(suidsOnlineDetail))
          vm.checkFlag = true
          vm.studentList = []
          for (let item of suidsOnlineDetail) {
            console.log('checkUserInfo--------------1')
            await vm.checkUserInfo(item, 1)
            const cango = JSON.parse(sessionStorage.getItem(String(item.user_id)))
            item = Object.assign(item, cango, {'value': item.user_id})
            vm.studentList.push(item)
            //这里都是登录事件，不加到事件里
            //vm.msgBusList = [item]
          }
          Bus.$emit('msg', vm.studentList)
          sessionStorage.setItem('studentList', JSON.stringify(vm.studentList));
          vm.$store.commit('SET_STUDENT_LIST', vm.studentList);
          vm.getMsg50()
        }
        // else if (event === 'CHECK_ONLINE_LIST' && !vm.investFlag ) {
        //   // 针对个别题目   点开题目未做操作  获取题目信息需要从user_ids_online_detail  中获取
        //   const suidsOnlineDetail = msg.user_ids_online_detail
        //   sessionStorage.setItem('suidsOnlineDetail', JSON.stringify(suidsOnlineDetail))
        //   suidsOnlineDetail.forEach(function(item) {
        //     console.log('checkUserInfo--------------2')
        //     vm.checkUserInfo(item)
        //   })
        // }
        else if (event === 'LOGIN') {
          console.log('checkUserInfo--------------3')
          vm.checkUserInfo(msg, 1).then(function(data) {
            msg = Object.assign(msg, data)
            vm.addMessage(msg)
          })
          if (msg.role == 'STUDENT') {
            console.log('checkUserInfo--------------4')
            //有学生登入了
            //清除下线延时器
            vm.clearLogoutTimer(msg)
            vm.sendTeacherOnLineMonitorMsg(msg)
            //vm.addSuperintendLog(msg);
            vm.checkUserInfo(msg, 1).then(function(data) {
              msg = Object.assign(msg, data)
              vm.addStudent(msg)
            })
          } else {
            vm.addStudent(msg)
          }
        } else if (event === 'RELOGIN') {
          if (vm.user_type == 4) {
            const checkStudentMsg = {
              'event': 'CHECK_ONLINE_LIST',
              'teacher_id': sessionStorage.getItem('teacher_id'),
              'role': vm.roleObject[sessionStorage.getItem('user_type')],
              'subject_id': sessionStorage.getItem('subject_id'),
              'refer_teacher_id': sessionStorage.getItem('refer_teacher_id'),
            }
            $_chat.sendMessage(checkStudentMsg)
          } else {
            const checkStudentMsg = {
              'event': 'CHECK_ONLINE_LIST',
              'teacher_id': sessionStorage.getItem('teacher_id'),
              'subrole': vm.roleObject[sessionStorage.getItem('user_type')],//(HEADMASTER:校长，CC:课程顾问, OPERATOR:运营)
              'role': 'SUPERVISOR', // :SUPERVISOR，(STUDENT:学生, TEACHER:分析员, SUPERVISOR:监控者)
              'subject_id': sessionStorage.getItem('subject_id'),
              'refer_teacher_id': sessionStorage.getItem('refer_teacher_id'),
            }
            $_chat.sendMessage(checkStudentMsg)
          }
          if (msg.role == 'STUDENT') {
            console.log('checkUserInfo--------------5')
            vm.clearLogoutTimer(msg)
            //有学生登入了
            vm.sendTeacherOnLineMonitorMsg(msg)
            //vm.addSuperintendLog(msg);
            vm.checkUserInfo(msg).then(function(data) {
              msg = Object.assign(msg, data)
              vm.addMessage(msg)
              vm.reloginStudent(msg)
            })
          } else {
            vm.reloginStudent(msg)
          }
        } else if (['LOGOUT', 'PAD_LOCK_SCREEN', 'PAD_HOME', 'PAD_MENU'].includes(event)) {//下线
          //vm.addSuperintendLog(msg);
          vm.removeStudent(msg)
        }  else if (event === 'DESTROY_ROOM') {//下线删除卡片
          //vm.addSuperintendLog(msg);
          vm.destroyRoomObj[msg.account_id] = msg
          //vm.destroyRoom(msg)
        } else if (event === 'ONLINE_STUDENT_CACHED_MSG') {
          if (!vm.cacheFlag) {
            for (const item of msg.user_ids_online) {
              if (msg.cached_msg[item][0]) {
                console.log('checkUserInfo--------------7')
                var userInfo = await vm.checkUserInfo(JSON.parse(msg.cached_msg[item][0]))
                msg.cached_msg[item].forEach(val => {
                  const params = JSON.parse(val)
                  params['disposeStatus'] = true
                  params['showOp'] = false
                  params['c_time'] = params.server_time
                  // params['isHeight'] = JSON.parse(sessionStorage.getItem(params.user_id)).isHeight || 0
                  params['msgShow'] = true
                  //只加报警信息
                  if(vm.alarmLimitList.indexOf(params.event)>-1){
                    vm.addMessage(Object.assign(params, userInfo))
                  }
                  //vm.messageList.unshift(Object.assign(params, userInfo))
                })
              }
            }
            //Bus.$emit('messageList', vm.messageList.sort((a, b) => {
              //return b.c_time - a.c_time
            //}))
            //vm.$store.commit('SET_MESSAGE_LIST', vm.messageList.sort((a, b) => {
              //return b.c_time - a.c_time
            //}));
            vm.cacheFlag = true;
          }
        } else if (event === 'ONLINE_STUDENT_CACHED_EVENT') {
          let cacheMsg = msg.cached_msg
          if (!vm.cacheEventFlag) {
            let msgBusList = vm.msgBusList
            for (var cacheItem of Object.keys(cacheMsg)) {
              const cango = JSON.parse(sessionStorage.getItem(cacheItem))
              console.log('checkUserInfo--------------8')
              var userInfo = await vm.checkUserInfo(JSON.parse(cacheMsg[cacheItem][0]), 1)
              var  cacheMsgArray = Object.assign(JSON.parse(cacheMsg[cacheItem][0]), cango, userInfo)
              //vm.msgBusList.unshift(cacheMsgArray)
              vm.msgBusList = [cacheMsgArray]
            }
            vm.cacheEventFlag = true;
          }
          vm.$store.commit('SET_CACHED_MSG', cacheMsg)
        } else if (event === 'KICKED_OUT' || event === "TEACHER_KICKED_OUT") {
          if (vm.user_type == 4) {
            vm.centerDialogVisible = true
          }
        }  else if (event === 'INVITE_STUDENT') {
            const checkStudentMsg = {
            'event': 'CHECK_ONLINE_LIST',
            'teacher_id': sessionStorage.getItem('teacher_id'),
            'role': vm.roleObject[sessionStorage.getItem('user_type')],
            'subject_id': sessionStorage.getItem('subject_id'),
            'refer_teacher_id': sessionStorage.getItem('refer_teacher_id'),
          }
          $_chat.sendMessage(checkStudentMsg)
          vm.investFlag = true
          //有学生登入了
          vm.sendTeacherOnLineMonitorMsg(msg)
          //vm.addSuperintendLog(msg);
        } else if (event === 'CHECK_ONLINE_LIST' && vm.investFlag) {
          vm.investFlag = false
          vm.studentList = [];
          const suidsOnlineDetail = msg.user_ids_online_detail
          sessionStorage.setItem('suidsOnlineDetail', JSON.stringify(suidsOnlineDetail))
          for (let item of suidsOnlineDetail) {
            console.log('checkUserInfo--------------9')
            await vm.checkUserInfo(item, 1)
            const cango = JSON.parse(sessionStorage.getItem(String(item.user_id)))
            item = Object.assign(item, cango, {'value': item.user_id})
            vm.studentList.push(item)
            //vm.msgBusList.push(item)
            vm.msgBusList = [item]
          }
          let studentListCard = vm.studentListCard
          Bus.$emit('msg', vm.studentList)
        } else if (// 拦截无用通知
          event !== 'JOIN_STUDENT_IN' &&
          event !== 'CLOSE_STUDENT_CARD' &&
          event !== 'CLICK_STUDENT_CARD' &&
          event !== 'CLICK_STUDENT_TAB' &&
          event !== 'CHECK_QUESTION_DETAIL' &&
          event !== 'CHECK_WARN_VIDEO_DETAIL' &&
          event !== 'CORRECT_SUBJECTIVE_QUESTION' &&
          event !== 'UNFOLD_WARN_MESSAGE' &&
          event !== 'CHOICE_QUESTION_HESITATE' &&
          event !== 'CHECK_WARN_QUESTION_DETAIL' &&
          event !== 'MOUSE_OVER_CHOICE_OPTION' &&
          event !== 'INVITE_STUDENT' &&
          event !== 'CHECK_ONLINE_LIST' &&
          event !== 'ONLINE_STUDENT_CACHED_MSG_SCHOOL' &&
          event !== 'CHECK_ONLINE_LIST_SCHOOL' &&
          event !== 'ONLINE_STUDENT_CACHED_EVENT_SCHOOL' &&
          event !== 'TEACHER_ONLINE_MONITOR' &&
          event !== 'WARN_MODULE_END') {
          var reg = /[\s\S]*?TABLET[\s\S]*?/
          if (reg.test(event)) {
            return false
          }
          console.log(i18n.t('studentList.allStudent.631798-16'), msg)
          /*if(!msg.user_id)
          {
            return false
          }*/
          //消息3s延迟,不包含报警
          //&& vm.currentViewStudent['user_id'] != msg['user_id']
          if(vm.alarmLimitList.indexOf(msg.event) == -1){
            getMsgContorl.addMsg(msg)
            return
          }
          vm.checkUserInfoFun(msg)
          return;
          vm.checkUserInfo(msg).then(function(data) {
            msg = Object.assign(msg, data)
            let correct_notify = data.correct_notify;
            if (event == "SUBMIT_ANSWER") {
              setTimeout(() => {
                if (event == 'SUBMIT_ANSWER') {
                  let subject_id = msg.subject_id;
                  let account_id = msg.account_id;
                  let user_id = msg.user_id;
                  let course_id = msg.course_id;
                  let module_name = msg.module_name;
                  let course_version = msg.learning_version;
                  let topic_id = msg.topic_id;
                  let module_id = msg.module_type;
                  let flow_id = msg.flow_id;
                  let userInfo = {
                    subject_id,
                    account_id,
                    user_id,
                    course_id,
                    course_version,
                    topic_id,
                    module_id,
                    flow_id
                  }
                  vm.queryUserStatInfo(userInfo, correct_notify);
                }
              }, 2000)
              // 当前答题事件
            }
            vm.addMessage(msg)
          }).catch(ex=>{
            console.log(ex,'ex')
          })
        }
      })
      const network = new networkReport(sessionStorage.getItem('school_id'),sessionStorage.getItem('teacher_id'))

      Bus.$on('navBarViewStudent', (item, index) => {
        let user_id = item['user_id'];
        const st = this.studentListCard.filter(event_cell => event_cell.user_id == user_id)
        // debugger
        const qId = (typeof st[0].data[0].question_ids !== 'undefined' && st[0].data[0].question_ids instanceof Array) ? st[0].data[0].question_ids.join(',') : ''
        const topicId = typeof st[0].data[0].topic_id !== 'undefined' ? st[0].data[0].topic_id : ''
        const subject_id = typeof st[0].data[0].subject_id !== 'undefined' ? st[0].data[0].subject_id : ''
        const school_id = typeof st[0].data[0].school_id !== 'undefined' ? st[0].data[0].school_id : ''
        const flow_id = typeof st[0].data[0].flow_id !== 'undefined' ? st[0].data[0].flow_id : ''
        const jupiter_stage = typeof st[0].data[0].stage !== 'undefined' ? st[0].data[0].stage : ''
        const course_id = typeof st[0].data[0].course_id !== 'undefined' ? st[0].data[0].course_id : ''
        const learning_version = typeof st[0].data[0].learning_version !== 'undefined' ? st[0].data[0].learning_version : ''
        const module_type = typeof st[0].data[0].module_type !== 'undefined' ? st[0].data[0].module_type : ''
        const module_name = typeof st[0].data[0].module_name !== 'undefined' ? st[0].data[0].module_name : ''
        const lesson_id = typeof st[0].data[0].lesson_id !== 'undefined' ? st[0].data[0].lesson_id : ' '
        const tag_code = typeof st[0].data[0].tag_code !== 'undefined' ? st[0].data[0].tag_code : ' '
        const question_bank_version = typeof st[0].data[0].question_bank_version !== 'undefined' ? st[0].data[0].question_bank_version : ''
        const question_vno = typeof st[0].data[0].question_vno !== 'undefined' ? st[0].data[0].question_vno : 0
        if (st) {
          this.viewStudentDetail(st[0], index);
          if  (this.$route.path != '/supervise/detail') {
            let query = {
              subject_id: subject_id,
              user_id: user_id,
              account_id: st[0].data[0].account_id,
              course_id: course_id,
              learning_version: learning_version,
              lesson_id: lesson_id,
              topic_id: topicId,
              knowledge_code: tag_code,
              flow_id: flow_id,
              question_ids: qId,
              index: index
            }
            this.$router.push({ path: '/supervise/detail', query: {} });
          }
        }
      })

      // 重置某个学生的主观题批改数据
      Bus.$on('resetZgtNum', (user_id, correct_notify_num) => {
        for (let i=0; i < this.studentListCard.length; i++) {
          let student = this.studentListCard[i];
          if (student['user_id'] == user_id) {
            let newStudent = student;
            newStudent.data[0].correct_notify = correct_notify_num;
            this.$set(this.studentListCard, i, newStudent);
            break;
          }
        }
      })

      // 答题后更新学生的今日相关的数据
      Bus.$on('updateStudentStatus', (msg) => {
        let subject_id = msg.subject_id;
        let account_id = msg.account_id;
        let user_id = msg.user_id;
        let course_id = msg.course_id;
        let module_name = msg.module_name;
        let course_version = msg.learning_version;
        let topic_id = msg.topic_id;
        let module_id = msg.module_type;
        let flow_id = msg.flow_id;
        let userInfo = {
          subject_id,
          account_id,
          user_id,
          course_id,
          course_version,
          topic_id,
          module_id,
          flow_id
        }
        vm.queryUserStatInfo(userInfo);
      })

      Bus.$on('msg', (e) => {
        //this.onlineStudentCount = e.length;
        //this.nowOnlineStudent = {};
        //this.nowOnlineStudent['count'] = e.length;
      })
      //this.queryAuthUserCount();
    },
    methods: {
      //整理信息
      checkUserInfoFun(msg,flag){
        const vm = this;
        const event = msg.event
        let with_extend = 0
        if(flag == 'with_extend' || msg.event == "GET_QUESTION"){
          with_extend = 1
          if(flag == 'with_extend'){
            flag = ''
          }
        }
        vm.checkUserInfo(msg,with_extend).then(function(data) {
            console.log(event,888091)
            msg = Object.assign(msg, data)
            let correct_notify = data.correct_notify;
            if (event == "SUBMIT_ANSWER" || flag) {
              setTimeout(() => {
                if (event == 'SUBMIT_ANSWER' || flag) {
                  let subject_id = msg.subject_id;
                  let account_id = msg.account_id;
                  let user_id = msg.user_id;
                  let course_id = msg.course_id;
                  let module_name = msg.module_name;
                  let course_version = msg.learning_version;
                  let topic_id = msg.topic_id;
                  let module_id = msg.module_type;
                  let flow_id = msg.flow_id;
                  let userInfo = {
                    subject_id,
                    account_id,
                    user_id,
                    course_id,
                    course_version,
                    topic_id,
                    module_id,
                    flow_id
                  }
                  vm.queryUserStatInfo(userInfo, correct_notify);
                }
              }, 2000)
              // 当前答题事件
            }
            vm.addMessage(msg)
          }).catch(ex=>{
            console.log(ex,'ex')
          })
      },
      // 学生重新登录后，清除之前的定时器
      clearLogoutTimer(params) {
        if (params.user_id && this.logOutTimeOutArr[params.user_id]) {
          clearTimeout(this.logOutTimeOutArr[params.user_id])
          this.logOutTimeOutArr[params.user_id] = null
        }
      },
      //列表页3s批量请求
      batchGetData(params) {
        const vm = this
        const p = new Promise(function(resolve, reject) {
          getMultiInfoBatch(params).then(res => {
            if (res.code == 200) {
              const data = res.data
              resolve(data)
            }
          }).catch(err => {
            // console.log(err);
          })
        })
        return p
      },
      getUserInfo(user_id)
      {
        for(let i=0;i<this.studentListCard.length;i++)
        {
          if(this.studentListCard[i].user_id==user_id)
          {
            return this.studentListCard[i]
          }
        }
      },
      addSuperintendLog(data)
      {
        let userInfo = this.getUserInfo(data.user_id)
        let studentUserName=''
        let studentName = ''
        if(userInfo)
        {
          studentUserName =userInfo['nick']
          studentName =userInfo['real_name']
        }
        let postData = {
        socket_id: data.socket_id,
        subject_id: data.subject_id,
        stu_account_id: data.account_id,
        stu_role_id: data.user_id,
        stu_uname: studentUserName,
        stu_real_name: studentName,
      }
        addSuperintendLog(postData).then((res)=>{
          if(res.code !=200)
          {
            console.error(res,'addSuperintendLog')
          }
        })

      },
      // 教师正在监课
      sendTeacherOnLineMonitorMsg(student)
      {
          const msg = {
            'event': 'TEACHER_ONLINE_MONITOR',
            'role': "TEACHER",
            'user_id':student.user_id,
            'subject_id': sessionStorage.getItem('subject_id'),
            'teacher_id': sessionStorage.getItem('teacher_id'),
            }
            setTimeout(() => {
              $_chat.sendMessage(msg) // 1秒后发送，防止学生端收不到
            }, 1000);

      },
      reloadPage() {
        window.close();
      },
      //获取在线学生列表事件
      checkOnlineList(isRepeat){
        const vm = this
        if (this.user_type == 4) {
          const checkStudentMsg = {
            'event': 'CHECK_ONLINE_LIST',
            'teacher_id': sessionStorage.getItem('teacher_id'),
            'role': vm.roleObject[sessionStorage.getItem('user_type')],
            'subject_id': sessionStorage.getItem('subject_id'),
            'school_id': vm.school_id,
            'refer_teacher_id': sessionStorage.getItem('refer_teacher_id'),
          }
          $_chat.sendMessage(checkStudentMsg,isRepeat)
        } else {
          const checkStudentMsg = {
            'event': 'CHECK_ONLINE_LIST',
            'teacher_id': sessionStorage.getItem('teacher_id'),
            'subject_id': sessionStorage.getItem('subject_id'),
            'school_id': vm.school_id,
            'refer_teacher_id': sessionStorage.getItem('refer_teacher_id'),
            'subrole': vm.roleObject[sessionStorage.getItem('user_type')],//(HEADMASTER:校长，CC:课程顾问, OPERATOR:运营)
            'role': 'SUPERVISOR', // :SUPERVISOR，(STUDENT:学生, TEACHER:分析员, SUPERVISOR:监控者)
          }
          $_chat.sendMessage(checkStudentMsg,isRepeat)
        }
      },
      // 获取50条数据
      getMsg50() {
        if (this.user_type == 4) {
          const onlineStudentMsg = {
            'event': 'ONLINE_STUDENT_CACHED_MSG',
            'teacher_id': sessionStorage.getItem('teacher_id'),
            'subject_id': sessionStorage.getItem('subject_id'),
            'role': this.roleObject[sessionStorage.getItem('user_type')],
            'refer_teacher_id': sessionStorage.getItem('refer_teacher_id'),
            'school_id': sessionStorage.getItem('school_id')
            // 'teacher_id': 2984
          }
          $_chat.sendMessage(onlineStudentMsg)
          const onlineStudentEvent = {
            'event': 'ONLINE_STUDENT_CACHED_EVENT',
            'teacher_id': sessionStorage.getItem('teacher_id'),
            'subject_id': sessionStorage.getItem('subject_id'),
            // 'role': this.roleObject[sessionStorage.getItem('user_type')],
            'refer_teacher_id': sessionStorage.getItem('refer_teacher_id'),
            'role': this.roleObject[sessionStorage.getItem('user_type')], // :SUPERVISOR，(STUDENT:学生, TEACHER:分析员, SUPERVISOR:监控者)
            'school_id': sessionStorage.getItem('school_id')
            // 'teacher_id': 2984
          }
          $_chat.sendMessage(onlineStudentEvent)
        } else {
          const onlineStudentMsg = {
            'event': 'ONLINE_STUDENT_CACHED_MSG',
            'teacher_id': sessionStorage.getItem('teacher_id'),
            'subject_id': sessionStorage.getItem('subject_id'),
            'subrole': this.roleObject[sessionStorage.getItem('user_type')],//(HEADMASTER:校长，CC:课程顾问, OPERATOR:运营)
            'role': 'SUPERVISOR', // :SUPERVISOR，(STUDENT:学生, TEACHER:分析员, SUPERVISOR:监控者)
            'refer_teacher_id': sessionStorage.getItem('refer_teacher_id'),
            'school_id': sessionStorage.getItem('school_id')
            // 'teacher_id': 2984
          }
          $_chat.sendMessage(onlineStudentMsg)
          const onlineStudentEvent = {
            'event': 'ONLINE_STUDENT_CACHED_EVENT',
            'teacher_id': sessionStorage.getItem('teacher_id'),
            'subject_id': sessionStorage.getItem('subject_id'),
            'subrole': this.roleObject[sessionStorage.getItem('user_type')],//(HEADMASTER:校长，CC:课程顾问, OPERATOR:运营)
            'role': 'SUPERVISOR', // :SUPERVISOR，(STUDENT:学生, TEACHER:分析员, SUPERVISOR:监控者)
            'refer_teacher_id': sessionStorage.getItem('refer_teacher_id'),
            'school_id': sessionStorage.getItem('school_id')
            // 'teacher_id': 2984
          }
          $_chat.sendMessage(onlineStudentEvent)
        }
      },
      // 子组件点了某个学生
      viewStudentDetail(val, index) {
        const vm = this
        this.checkUserInfoFun(val.data[0],'with_extend')
        const samePan = this.studentListPan.filter(same => same.user_id == val.user_id)
        if (samePan.length > 0) {
          vm.activePan = typeof val.user_id !== 'undefined' ? val.user_id + '' : val + ''
        } else {
          if (typeof index !== 'undefined') {
            const tempArray = val.data[0]
            tempArray.course_sname = val.data[0].course_sname
            tempArray.module_sname = val.data[0].module_sname
            tempArray.real_sname = val.data[0].real_sname || val.data[0].nick
            tempArray.course_sid = val.data[0].course_id
            tempArray.section_sname = val.data[0].section_sname
            tempArray.section_sid = val.data[0].section_id
            tempArray.topic_sname = val.data[0].topic_sname
            tempArray.topic_sid = val.data[0].topic_id
            tempArray.user_sname = val.data[0].nick
            tempArray.learning_version = val.data[0].learning_version ? val.data[0].learning_version: '',
            tempArray.real_name = val.real_name
            tempArray.nick = val.nick
            // tempArray.nick = val.data[0].nick
            tempArray.user_sid = val.data[0].user_id
            const userId = typeof val.user_id !== 'undefined' ? val.user_id + '' : val + ''
            // tempArray.isHeight = JSON.parse(sessionStorage.getItem(userId)).isHeight
            if (this.studentListPan[0].user_id === '0') {
              this.studentListPan.unshift({
                'event': 'LOGIN',
                'role': 'STUDENT',
                'user_id': '1',
                'tuid': i18n.t('studentList.allStudent.631798-6'), // 1.8版本新加
                'subject_id': i18n.t('studentList.allStudent.631798-7'), // 1.8版本新加
                'school_id': i18n.t('studentList.allStudent.631798-8'), // 1.8版本新加
                'cid': i18n.t('studentList.allStudent.631798-9'),
                'sid': i18n.t('studentList.allStudent.631798-10'),
                'tid': i18n.t('studentList.allStudent.631798-11'),
                'flow_id': i18n.t('studentList.allStudent.631798-12'),
                'nick': i18n.t('studentList.allStudent.631798-13'),
                'real_sname': i18n.t('studentList.allStudent.631798-13'),
                'app_type': i18n.t('studentList.allStudent.631798-14'), // 可以依据学校ID来区分线上或是线下
                'client_ip': i18n.t('studentList.allStudent.631798-15'),
                'index': 10
              })
            }
            this.studentListPan.push(tempArray)
            vm.activePan = typeof val.user_id !== 'undefined' ? val.user_id + '' : val + ''
            // vm.activePan = '0'
          }
        }
        // 字符串转换为数字
        const userId = typeof val.user_id !== 'undefined' ? val.user_id + '' : val + ''
        this.$nextTick(() => {
          Bus.$emit('studentListCard', val, index, this.studentListCard, 'detail')
        })
        if (samePan.length > 0) {
          vm.activePan = typeof val.user_id !== 'undefined' ? val.user_id + '' : val + ''
        } else {
          if (typeof index !== 'undefined') {
            // this.studentListPan.push(val.data[0])
            vm.activePan = typeof val.user_id !== 'undefined' ? val.user_id + '' : val + ''
            // vm.activePan = '0'
          }
        }

        if (typeof val === 'object') {
          if(this.user_type == 4) {
            // 学生卡片
            const CLICK_STUDENT_CARD = {
              'event': 'CLICK_STUDENT_CARD',
              'teacher_id': sessionStorage.getItem('teacher_id'),
              'subject_id': sessionStorage.getItem('subject_id'),
              'school_id': sessionStorage.getItem('school_id'),
              'app_type': val.data[0].app_type,
              'client_ip': val.data[0].client_ip,
              'user_id': val.data[0].user_id,
              'nick': val.data[0].nick,
              'course_id':val.data[0].course_id,
              'lesson_id':val.data[0].lesson_id,
              'topic_id':val.data[0].topic_id,
              'flow_id':val.data[0].flow_id,
              'question_bank_version': val.data[0].question_bank_version?val.data[0].question_bank_version: '',
              'question_vno': val.data[0].question_vno?val.data[0].question_vno: 0,
            }

            $_chat.sendMessage(CLICK_STUDENT_CARD)
          }

          var studentInfo = val.data[0]
          // 获取主观题
          if(index !== 'undefined') {
            sessionStorage.setItem('app_type', val.data[0].app_type)
            sessionStorage.setItem('client_ip', val.data[0].client_ip)
            sessionStorage.setItem('user_id', val.data[0].user_id)
            sessionStorage.setItem('nick', val.data[0].nick)
          }

          const params = {
            account_id: val.data[0].account_id || '',
            flow_id: val.data[0].flow_id || '',
            user_id: val.data[0].user_id || '',
            topic_id: val.data[0].topic_id || '',
            subject_id: val.data[0].subject_id || '',
            school_id: val.data[0].school_id || ''
          }
        }
      },
      studentDetailMsg(val, index) {
        const vm = this
        // const samePan = this.studentListPan.filter(same => same.user_id == val.user_id)
        let samePan = [];
        for (let i=0; i < this.studentListPan.length; i++) {
          if (this.studentListPan[i].user_id == val.user_id) {
            samePan.push(this.studentListPan[i]);
            break;
          }
        }
        if (samePan.length > 0) {
          vm.activePan = typeof val.user_id !== 'undefined' ? val.user_id + '' : val + ''

        } else {
          if (typeof index !== 'undefined') {
            const tempArray = val.data[0]
            tempArray.course_sname = val.data[0].course_sname
            tempArray.module_sname = val.data[0].module_sname
            tempArray.real_sname = val.data[0].real_sname || val.data[0].nick
            tempArray.course_sid = val.data[0].course_id
            tempArray.section_sname = val.data[0].section_sname
            tempArray.section_sid = val.data[0].section_id
            tempArray.topic_sname = val.data[0].topic_sname
            tempArray.topic_sid = val.data[0].topic_id
            tempArray.user_sname = val.data[0].nick
            tempArray.learning_version= val.data[0].learning_version?val.data[0].learning_version: '',
              tempArray.real_name = val.real_name
            tempArray.nick = val.nick
            // tempArray.nick = val.data[0].nick
            tempArray.user_sid = val.data[0].user_id
            const userId = typeof val.user_id !== 'undefined' ? val.user_id + '' : val + ''
            // tempArray.isHeight = JSON.parse(sessionStorage.getItem(userId)).isHeight
            if (this.studentListPan[0].user_id === '0') {
              this.studentListPan.unshift({
                'event': 'LOGIN',
                'role': 'STUDENT',
                'user_id': '1',
                'tuid': i18n.t('studentList.allStudent.631798-6'), // 1.8版本新加
                'subject_id': i18n.t('studentList.allStudent.631798-7'), // 1.8版本新加
                'school_id': i18n.t('studentList.allStudent.631798-8'), // 1.8版本新加
                'cid': i18n.t('studentList.allStudent.631798-9'),
                'sid': i18n.t('studentList.allStudent.631798-10'),
                'tid': i18n.t('studentList.allStudent.631798-11'),
                'flow_id': i18n.t('studentList.allStudent.631798-12'),
                'nick': i18n.t('studentList.allStudent.631798-13'),
                'real_sname': i18n.t('studentList.allStudent.631798-13'),
                'app_type': i18n.t('studentList.allStudent.631798-14'), // 可以依据学校ID来区分线上或是线下
                'client_ip': i18n.t('studentList.allStudent.631798-15'),
                'index': 10
              })
            }
            this.studentListPan.push(tempArray)
            vm.activePan = typeof val.user_id !== 'undefined' ? val.user_id + '' : val + ''
            // vm.activePan = '0'
          }
        }

        if (samePan.length > 0) {
          vm.activePan = typeof val.user_id !== 'undefined' ? val.user_id + '' : val + ''
        } else {
          if (typeof index !== 'undefined') {
            // this.studentListPan.push(val.data[0])
            vm.activePan = typeof val.user_id !== 'undefined' ? val.user_id + '' : val + ''
            // vm.activePan = '0'
          }
        }
        if (this.activePan != '1') {
          // 字符串转换为数字
          this.$nextTick(() => {
            const userId = typeof val.user_id !== 'undefined' ? val.user_id + '' : val + ''
            Bus.$emit('studentListCard', val, index, this.studentListCard, "SUBMIT_ANSWER")
          })
        }
        if (typeof val === 'object') {
          if(this.user_type == 4) {
            // 学生卡片
            const CLICK_STUDENT_CARD = {
              'event': 'CLICK_STUDENT_CARD',
              'teacher_id': sessionStorage.getItem('teacher_id'),
              'subject_id': sessionStorage.getItem('subject_id'),
              'school_id': sessionStorage.getItem('school_id'),
              'app_type': val.data[0].app_type,
              'client_ip': val.data[0].client_ip,
              'user_id': val.data[0].user_id,
              'nick': val.data[0].nick,
              'course_id':val.data[0].course_id,
              'lesson_id':val.data[0].lesson_id,
              'topic_id':val.data[0].topic_id,
              'flow_id':val.data[0].flow_id,
              'question_bank_version': val.data[0].question_bank_version?val.data[0].question_bank_version: '',
              'question_vno': val.data[0].question_vno?val.data[0].question_vno: 0,
            }

            $_chat.sendMessage(CLICK_STUDENT_CARD)
          }

          var studentInfo = val.data[0]
          // 获取主观题
          if(index !== 'undefined') {
            sessionStorage.setItem('app_type', val.data[0].app_type)
            sessionStorage.setItem('client_ip', val.data[0].client_ip)
            sessionStorage.setItem('user_id', val.data[0].user_id)
            sessionStorage.setItem('nick', val.data[0].nick)
          }
        }
      },
      // 学生下线后删除卡片
      closeCard(item, index) {
        this.$confirm(i18n.t('studentList.allStudent.631798-17'), i18n.t('studentList.allStudent.631798-18'), {
          confirmButtonText: i18n.t('studentList.allStudent.631798-19'),
          cancelButtonText: i18n.t('studentList.allStudent.631798-20'),
          type: 'warning',
          center: true
        }).then(() => {
          this.studentListCard = this.studentListCard.filter(close => close.user_id != item.user_id)
          this.studentList = this.studentList.filter(close => close.user_id != item.user_id)
          this.studentListPan = this.studentListPan.filter(close => close.user_id != item.user_id)
          this.msgBusList = this.msgBusList.filter(msg => msg.user_id != item.user_id)
          //this.messageList = this.messageList.filter(num => num.user_id != item.user_id)
          const user = String(item.user_id)
          // 更新报警区域学生列表
          Bus.$emit('msg', this.studentList)
          sessionStorage.setItem('studentList', JSON.stringify(this.studentList));
          this.$store.commit('SET_STUDENT_LIST', this.studentList);
          // 更新报警信息列表
          //Bus.$emit('messageList', this.messageList)
          sessionStorage.removeItem(user + '_wait')
          sessionStorage.removeItem(user)
          this.$message({
            type: 'success',
            message: i18n.t('studentList.allStudent.631798-21')
          })
          if (this.$route.path == '/supervise/detail' && this.studentListCard.length > 0) { // 当为学生详情页的时候
            let newStudentArr = this.sortStudentData(this.studentListCard);
            let firstStudent = newStudentArr[0];
            const st = this.studentListCard.filter(event_cell => event_cell.user_id == firstStudent['user_id'])
            this.$store.commit('SET_CURRENT_USER_ID', firstStudent['user_id']);
            this.viewStudentDetail(st[0], 0);
          } else if (this.$route.path == '/supervise/detail' && this.studentListCard.length == 0) { // 没有学生了
            this.$router.push({ path: "/supervise/", query: {} });
          }

          if(this.user_type == 4) {
            // 删除学生卡片
            const CLOSE_STUDENT_CARD = {
              'event': 'CLOSE_STUDENT_CARD',
              'teacher_id': sessionStorage.getItem('teacher_id'),
              'subject_id': sessionStorage.getItem('subject_id'),
              'school_id': sessionStorage.getItem('school_id'),
              'app_type': item.data[0].app_type,
              'client_ip': item.data[0].client_ip,
              'user_id': item.data[0].user_id,
              'nick': item.data[0].nick,
              'course_id':item.data[0].course_id,
              'lesson_id':item.data[0].lesson_id,
              'topic_id':item.data[0].topic_id,
              'flow_id':item.data[0].flow_id,
              'question_bank_version': item.data[0].question_bank_version?item.data[0].question_bank_version: '',
              'question_vno': item.data[0].question_vno?item.data[0].question_vno: 0,
            }
            $_chat.sendMessage(CLOSE_STUDENT_CARD)
          }
        }).catch(() => {
          this.$message({
            type: 'info',
            message: i18n.t('studentList.allStudent.631798-22')
          })
        })
      },
      //多个卡片时删除下线卡片
      destroyRoom(item,newItem) {
        this.studentListCard = this.studentListCard.filter(close => close.user_id != item.user_id)
        this.studentList = this.studentList.filter(close => close.user_id != item.user_id)
        this.studentListPan = this.studentListPan.filter(close => close.user_id != item.user_id)
        this.msgBusList = this.msgBusList.filter(msg => msg.user_id != item.user_id)
        //this.messageList = this.messageList.filter(num => num.user_id != item.user_id)
        const user = String(item.user_id)
        // 更新报警区域学生列表
        Bus.$emit('msg', this.studentList)
        sessionStorage.setItem('studentList', JSON.stringify(this.studentList));
        this.$store.commit('SET_STUDENT_LIST', this.studentList);
        // 更新报警信息列表
        //Bus.$emit('messageList', this.messageList)
        sessionStorage.removeItem(user + '_wait')
        sessionStorage.removeItem(user)
        this.sortStudentData(this.studentListCard);
        //console.log(this.$route.path == '/supervise/detail' && this.studentListCard.length > 0 && item.user_id != this.currentViewStudent.user_id,"wangwanlei")
        if (this.$route.path == '/supervise/detail' && this.studentListCard.length > 0 && item.account_id == this.currentViewStudent.account_id) { // 当为学生详情页的时候
          //let firstStudent = newStudentArr[0];
          //const st = this.studentListCard.filter(event_cell => event_cell.user_id == firstStudent['user_id'])
          this.$store.commit('SET_CURRENT_USER_ID', newItem['user_id']);
          this.viewStudentDetail(newItem, 0);
        } else if (this.$route.path == '/supervise/detail' && this.studentListCard.length == 0) { // 没有学生了
          this.$router.push({ path: "/supervise/", query: {} });
        }
      },
      //DESTROY_ROOM
      // 获取主观题
      getWaitQuestionsList(params) {
        const param = new Promise(function(resolve, reject) {
          const data = {
            flow_id: params.flow_id,
            account_id: params.account_id,
            user_id: params.user_id,
            topic_id: params.topic_id,
            subject_id: params.subject_id,
          }
          getSubjectiveQuestionList(data).then(res => {
            if (res.code === 200) {
              resolve(res.data)
            }
          }).catch(err => {
            // console.log(err);
          })
        })
        return param
      },
      // 当学生正在答题时，查询学生的用户统计信息
      queryUserStatInfo(userInfo, correct_notify) {
        console.log('correct_notifycorrect_notify==='+correct_notify)
        let params = {
          subject_id: userInfo['subject_id'],
          account_id: userInfo['account_id'],
          user_id: userInfo['user_id'],
          course_id: userInfo['course_id'],
          course_version: userInfo['course_version'] == 3 ? 10 : userInfo['course_version'],
          lesson_id: userInfo['lesson_id'],
          topic_id: userInfo['topic_id'],
          module_id: userInfo['module_id'],
          flow_id: userInfo['flow_id'],
        }
        userStatInfo(params).then(res => {
          if (res.code == 200) {
            let today_course_answer = res.data.today_course_answer
            let today_course_learn = res.data.today_course_learn
            let today_course_knowledge = res.data.today_course_knowledge
            let module_answer = res.data.module_answer
            let module_learn = res.data.module_learn
            for (let i=0; i < this.studentListCard.length; i++) {
              let currentStudent = this.studentListCard[i];
              if (currentStudent['user_id'] == userInfo['user_id']) {
                let newStudent = currentStudent;
                newStudent['today_course_answer'] = today_course_answer;
                newStudent['today_course_learn'] = today_course_learn;
                newStudent['today_course_knowledge'] = today_course_knowledge;
                newStudent['module_answer'] = module_answer;
                newStudent['module_learn'] = module_learn;
                newStudent['correct_notify'] = correct_notify;
                this.$set(this.studentListCard, i, newStudent);
                break;
              }
            }
            // 判断是否当前正在查看的学生
            if (this.currentViewStudent['user_id'] == userInfo['user_id']) {
              let oldCurrentViewStudent = this.currentViewStudent;
              oldCurrentViewStudent['today_course_answer'] = today_course_answer;
              oldCurrentViewStudent['today_course_learn'] = today_course_learn;
              oldCurrentViewStudent['today_course_knowledge'] = today_course_knowledge;
              oldCurrentViewStudent['module_answer'] = module_answer;
              oldCurrentViewStudent['module_learn'] = module_learn;
              oldCurrentViewStudent['correct_notify'] = correct_notify;
              oldCurrentViewStudent['isMonitorMsg'] = false;
              this.$store.commit("SET_CURRENT_VIEW_STUDENT", oldCurrentViewStudent);
            }
          }
        })
      },
      //格式化msg数据
      formatMsgData(params){
        const vm = this
        console.log(params,666666666)
        return new Promise(function(resolve, reject) {
          const userInfo = {}
          // 处理真实姓名为空或者为数字的情况
          const realName = params.real_sname
          if (typeof realName === 'number') {
            userInfo.real_sname = realName.toString()
          } else if (realName == '') {
            userInfo.real_sname = params.user_sname
          } else {
            userInfo.real_sname = realName
          }
          userInfo.module_sname = params.module_name || ''
          userInfo.module_stype = params.module_type || ''
          // 是否高中 0 否  1是
          if (params.learning_version == 2) {
            userInfo.isHeight = 1
          } else {
            userInfo.isHeight = 0
          }
          // 今日正答率
          userInfo.today_course_answer = params.today_course_answer || 0
          // 今日知识点掌握率
          userInfo.today_course_knowledge = params.today_course_knowledge || 0
          // 学习时长
          userInfo.today_course_learn = params.today_course_learn || 0
          // 主观题待批改的标志
          //userInfo.correct_notify = params.correct_notify
          // 当前模块答题统计数据  待定
          //if (data.module_answer && params.module_type) {
            //userInfo.module_answer = data.module_answer
          //}
          // 当前模块学习用时  待定
          //if (data.module_learn && params.module_type) {
            //userInfo.module_learn = data.module_learn
          //}
          if (!vm.systemTime) {
            if (vm.systemTimer == null) {
              vm.systemTimer = setInterval(()=>{
                let timeFormat = params.server_time;
                vm.$store.commit('SET_SYSTEM_TIME', timeFormat + 5000);
              },5000)
            }
          }
          const newUser = String(params.user_id)
          sessionStorage.setItem(newUser, JSON.stringify(userInfo))
          resolve(userInfo)
        })
      },
      // 调取学习内容及用户信息接口总
      checkUserInfo(params, with_extend) {
        if(!params.user_id){
          return;
        }
        //if(params.role == "STUDENT" && this.alarmLimitList.concat(["MODULE_START",'GET_ANALYSIS']).includes(params.event)){
          //return this.formatMsgData(params)
        //}
        const vm = this
        const p = new Promise(function(resolve, reject) {
          console.log('checkUserInfocheckUserInfo-------', params)
          const data = {
            school_id: params.school_id,
            user_id: params.user_id,
            course_id: params.course_id,
            topic_id: params.topic_id,
            lesson_id: params.lesson_id,
            knowledge_code: params.tag_code,
            stage: params.module_type,
            flow_id: params.flow_id,
            subject_id: params.subject_id,
            jupiter_stage: params.stage,
            learning_version: params.learning_version ? params.learning_version: '',
            question_bank_version: params.question_bank_version ? params.question_bank_version: '',
            question_vno: params.question_vno ? params.question_vno : 0,
            //module_id: params.module_type ? params.module_type : 0,
            module_id: 0,
            with_extend: with_extend == 1 ? 1 : 0
          }
          getMultiInfo(data).then(res => {
            if (res.code == 200) {
              const data = res.data
              const userInfo = {}
              let course_version = '';
              userInfo.course_info = data.course_info
              userInfo.course_sname = data.course_info.course_name
              userInfo.course_sid = data.course_info.course_id
              userInfo.learn_type = data.course_info.learn_type
              if (data.course_info.course_version) {
                  course_version = data.course_info.course_version;
              }
              if (course_version != 10 && data.lesson_info) {
                userInfo.section_sname = data.lesson_info.lesson_name
                userInfo.section_sid = data.lesson_info.lesson_id
              }
              userInfo.topic_sname = data.topic_info.topic_name
              userInfo.topic_sid = data.topic_info.topic_id
              userInfo.course_version = data.course_info.course_version;

              // 处理真实姓名为空或者为数字的情况
              const realName = data.user_info.real_name
              if (typeof realName === 'number') {
                userInfo.real_sname = realName.toString()
              } else if (realName == '') {
                userInfo.real_sname = data.user_info.user_name
              } else {
                userInfo.real_sname = realName
              }
              userInfo.user_sname = data.user_info.user_name
              userInfo.user_sid = params.user_id
              if (data.user_info.is_correct) {
                userInfo.is_correct = data.user_info.is_correct
              }
              if (data.knowledge_info) {
                userInfo.tag_sname = data.knowledge_info.tag_name
                userInfo.tag_scode = data.knowledge_info.tag_code
              } else {
                userInfo.tag_sname = ''
                userInfo.tag_scode = ''
              }
              userInfo.module_sname = params.module_name
              userInfo.module_stype = params.module_type
              // 是否高中 0 否  1是
              if (data.learning_version == 2) {
                userInfo.isHeight = 1
              } else {
                userInfo.isHeight = 0
              }
              // 今日正答率
              userInfo.today_course_answer = data.today_course_answer
              // 今日知识点掌握率
              userInfo.today_course_knowledge = data.today_course_knowledge
              // 学习时长
              userInfo.today_course_learn = data.today_course_learn
              // 主观题待批改的标志
              userInfo.correct_notify = data.correct_notify
              // 当前模块答题统计数据
              if (data.module_answer && params.module_type) {
                userInfo.module_answer = data.module_answer
              }
              // 当前模块学习用时
              if (data.module_learn && params.module_type) {
                userInfo.module_learn = data.module_learn
              }
              if (!vm.systemTime) {
                if (vm.systemTimer == null) {
                  vm.systemTimer = setInterval(()=>{
                    let timeFormat = '';
                    if (vm.systemTime == '') {
                      let time = res.time.replace(/-/g, '/');
                      timeFormat = (new Date(time)).getTime();
                    } else {
                      let time = vm.systemTime;
                      timeFormat = time;
                    }
                    vm.$store.commit('SET_SYSTEM_TIME', timeFormat + 5000);
                  },5000)
                }
              }
              const newUser = String(params.user_id)
              sessionStorage.setItem(newUser, JSON.stringify(userInfo))
              resolve(userInfo)
            }
          }).catch(err => {
             console.log('err',err);
          })
        })
        return p
      },
      // 查询学生的一些基础信息
      queryUserBasicsInfo(params) {
        const p = new Promise(function(resolve, reject) {
          const data = {
            subject_id: params.subject_id,
            user_id: params.user_id
          }
          getUserInfo(data).then(res => {
            if (res.code == 200) {
              const data = res.data
              const userInfo = {}
              userInfo.account_id = data.account_id;
              if (data.real_name) {
                userInfo.real_name = data.real_name;
              }
              resolve(userInfo)
            }
          })
        })
      },
      // 学生上线
      addStudent(params) {
        const vm = this
        let userData = {}
        if (typeof params !== 'undefined') {
          userData = params
        }
        if (userData.role === 'STUDENT') {
          var even = function(element) {
            // checks whether an element is even
            return element == sessionStorage.getItem('teacher_id');
          };
          var even2 = function(element) {
            // checks whether an element is even
            return element == sessionStorage.getItem('refer_teacher_id');
          };
          if(vm.user_type == 4 && params.teacher_id.split(',').some(even) || params.teacher_id.split(',').some(even2)) {
            const studentFilter = vm.studentList.filter(student => student.user_id == userData.user_id)
            const onlineStudentFilter = this.onlineStudentList.filter(student => student.user_id == userData.user_id)
            if (onlineStudentFilter.length === 0 && studentFilter.length === 0) {
              vm.onlineStudentList.push(userData)
            } else {
              vm.reloginStudent(userData)
            }
            userData.disposeStatus = true
            userData.offLineStatus = false
            userData.c_time = params.server_time || new Date().getTime()
            userData.msgShow = true
            // userData.handleStatus = 1  // 学生当前的状态，2-置顶 1-默认 0-沉底，暂时不看他
            userData.initTime = new Date().getTime()
            this.addMessage(userData)
            //this.messageList.unshift(userData)
          }
        }
      },
      // 学生加入卡片
      addStudents(params) {
        const vm = this
        this.onlineStudentList.forEach(function(onlineStudent) {
          const cango = JSON.parse(sessionStorage.getItem(String(onlineStudent.user_id)))
          onlineStudent = Object.assign(onlineStudent, cango)
          //vm.msgBusList.unshift(onlineStudent);
          vm.msgBusList = [onlineStudent]
          vm.cacheEventFlag = false;
          vm.cacheFlag = false;
          if (vm.user_type == 4) {
            // 加入学生
            const JOIN_STUDENT_IN = {
              'event': 'JOIN_STUDENT_IN',
              'teacher_id': sessionStorage.getItem('teacher_id'),
              'subject_id': sessionStorage.getItem('subject_id'),
              'school_id': sessionStorage.getItem('school_id'),
              'app_type': onlineStudent.app_type,
              'client_ip': onlineStudent.client_ip,
              'user_id': onlineStudent.user_id,
              'nick': onlineStudent.nick,
              'course_id':onlineStudent.course_id,
              'lesson_id':onlineStudent.lesson_id,
              'topic_id':onlineStudent.topic_id,
              'flow_id':onlineStudent.flow_id,
              'question_bank_version': onlineStudent.question_bank_version?onlineStudent.question_bank_version: '',
              'question_vno': onlineStudent.question_vno?onlineStudent.question_vno: 0,
            }
            $_chat.sendMessage(JOIN_STUDENT_IN)
          }

        })

        this.studentList = this.studentList.concat(this.onlineStudentList)
        Bus.$emit('msg', this.studentList)
        this.onlineStudentList = []
        this.onlineStudentStatus = false
        this.getMsg50()
      },
      // 学生重新登录
      reloginStudent(params) {
        // debugger
        if (params.role === 'STUDENT') {
          const vm = this
          vm.cacheEventFlag = false;
          vm.cacheFlag = false;
          var even = function(element) {
            // checks whether an element is even
            return element == sessionStorage.getItem('teacher_id');
          };
          var even2 = function(element) {
            // checks whether an element is even
            return element == sessionStorage.getItem('refer_teacher_id');
          };
          if(vm.user_type == 4 && params.teacher_id.split(',').some(even) || params.teacher_id.split(',').some(even2)) {
            const haveonline = this.onlineStudentList.filter(student => student.user_id == params.user_id)
            // 卡片为零 加入监课 列表 并且列表不重复
            if (this.studentListCard.length === 0) {
              if (haveonline.length === 0) {
                vm.onlineStudentList.push(params)
              }
            }
            // 卡片不为零
            else {
              const difItems = this.studentListCard.filter(cards => cards.user_id == params.user_id)
              // 加入列表不重复 并且不在卡片中显示 提示加入
              if (difItems.length === 0 && haveonline.length === 0) {
                vm.onlineStudentList.push(params)
              }
              // 已加入卡片 改变卡片的状态
              else {
                for (const index in this.studentListCard) {
                  if (this.studentListCard[index].user_id == params.user_id) {
                    vm.studentListCard[index].offLineStatus = false
                    const userData = params
                    userData.disposeStatus = true
                    userData.offLineStatus = false
                    userData.c_time = params.server_time || new Date().getTime()
                    userData.msgShow = true
                    userData.isJieru = 1
                    // userData.handleStatus = 1
                    userData.initTime = new Date().getTime();
                    // 学生重新登录后，清除之前的定时器
                    this.clearLogoutTimer(userData)
                    //this.messageList.unshift(userData)
                    this.addMessage(userData)
                    //this.msgBusList.unshift(userData)
                    this.msgBusList = [userData];
                    this.$nextTick(()=>{
                      this.sortStudentData(this.studentListCard)
                    })
                  }
                }
              }
            }
          }
        }
      },
      // 学生下线
      removeStudent(params) {
        const that = this
        if (params.role === 'STUDENT') {
          this.clearLogoutTimer(params)
          this.logOutTimeOutArr[params.user_id] = setTimeout(() => { // 延迟一分钟后，才把学生的卡片置灰
            for (const index in this.studentListCard) {
              console.log(55555,index,params.user_id)
              if (params.user_id == this.studentListCard[index].user_id) {
                let obj = this.studentListCard[index]
                obj.offLineStatus = true
                obj.data[0].c_time = NaN
                obj.data[0].server_time = params['server_time']
                this.$set(this.studentListCard,index,obj)
                console.log(555557,this.studentListCard)
                this.sortStudentData(this.studentListCard)
                console.log(i18n.t('studentList.allStudent.631798-24'))
              }
            }
          }, 1000 * this.offLineTime)
          this.onlineStudentList = this.onlineStudentList.filter(online => online.user_id !== params.user_id)
        }
      },
      // 其他 添加消息
      addMessage(msg) {
        console.log(msg,9999989,this.messageList,this.userList,this.studentList)
        const vm = this
        //期末复习的报警信息内没有题目信息，所以过滤报警
        //if(vm.alarmLimitList.indexOf(msg.event)>-1 && msg.learn_type == 42){
          //return
        //}
        //this.studentList.forEach((x, i) => {
          //if (x.nick !== i18n.t('studentList.allStudent.631798-13')) {
            //this.userList.push(x.user_id)
          //}
        //})
        var messageData = new Object()
        if (this.userList.length > 0) {
          const temp = JSON.stringify(msg)
          if (typeof msg !== 'undefined') {
            messageData = JSON.parse(temp)
          }
          messageData['disposeStatus'] = false
          messageData['showOp'] = false
          messageData['c_time'] = msg.server_time || new Date().getTime()
          messageData['msgShow'] = true
          //let msgIn = [];
          //for (let i=0; i < vm.studentListCard.length; i++) {
            //if (vm.studentListCard[i].user_id == messageData.user_id) {
              //msgIn.push(vm.studentListCard[i]);
              //break;
            //}
          //}
          //console.log(msgIn,999999,'msgIn')
          // const msgIn = vm.studentListCard.filter(student => student.user_id == messageData.user_id)
          if (messageData.event !== 'CHECK_ONLINE_LIST' && messageData.event !== 'KICKED_OUT') {
            //this.msgBusList.unshift(messageData)
            this.msgBusList = [messageData]
          }

          if (messageData.role === 'STUDENT' && this.messageLimitList.indexOf(messageData.event) > -1) {
            // const hasOnline = this.studentListCard.filter(card => card.user_id == messageData.user_id)
            //if (msgIn.length > 0) {
              //this.messageList.unshift(messageData)
            //}
            //Bus.$emit('messageList', this.messageList.sort((a, b) => { return b.c_time - a.c_time }))
            Bus.$emit('msg', this.studentList)
            sessionStorage.setItem('studentList', JSON.stringify(this.studentList));
            this.$store.commit('SET_STUDENT_LIST', this.studentList);
          }
        }
      },
      getId(index) {
        return 'icon' + index
      },
      // 设置正答率排序
      setAnswerRate (sort) {
        if (sort == 'ascending' || sort == 'descending') {
          this.answerRate = sort;
        } else {
          this.answerRate = this.answerRate == 'ascending' ? 'descending' : 'ascending';
        }
      },
      // 设置掌握率
      setMasterRate (sort) {
        if (sort == 'ascending' || sort == 'descending') {
          this.masterRate = sort;
        } else {
          this.masterRate = this.masterRate == 'ascending' ? 'descending' : 'ascending';
        }
      },
      choiceShowType (type) {
        this.showType = type;
      },
      setIntervene (lastReason) {
        let user_id = lastReason['user_id']
        let isIntervene = lastReason['isIntervene']
        if (this.studentListCard.length > 0) {
          this.studentListCard.map((item, index) => {
            let newItem = item
            if (user_id == 'all') {
              newItem['isJieru'] = isIntervene == 1 ? 1 : 0
              this.$set(this.studentListCard, index, newItem)
            } else {
              if (user_id == item['user_id']) {
                newItem['isJieru'] = isIntervene == 1 ? 1 : 0
                this.$set(this.studentListCard, index, newItem)
              }
            }
          })
        }
      },
      // 设置学生报警的列表
      setMessageDisposeStatus (user_id) {
        this.studentListCard.forEach((x, i) => {
          if (x.user_id == user_id) {
            let newCard = x;
            newCard['msgNum'] = 0;
            newCard.data.forEach(item=>{
              item.disposeStatus = true
            })
            this.$set(this.studentListCard, i, newCard);
          }
        })
        //this.messageList.map((item, index) => {
          //if (item.user_id == user_id) {
            //let newItem = item;
            //newItem.disposeStatus = true;
            //this.$set(this.messageList, index, newItem);
          //}
        //})
      },
      // 设置学生列表顺序
      handleStudent(selectItem, selectIndex, status) {
        let findIndex = -1;
        for (let i=0; i < this.studentListCard.length; i++) {
          let studentCard = this.studentListCard[i];
          if (selectItem['user_id'] == studentCard['user_id']) {
            findIndex = i;
            break;
          }
        }
        if (findIndex != -1) {
          let newSelectItem = selectItem;
          newSelectItem['handleStatus'] = status;
          newSelectItem['initTime'] = new Date().getTime();
          this.$set(this.studentListCard, findIndex, newSelectItem);
          this.sortStudentData(this.studentListCard)
        }
      },
      // 暂时不看ta
      notFollowTaOrFollow (selectItem, selectIndex) {
        // 从学生列表中找到学生之前的位置
        let oldIndex = '';
        this.studentList.map((item, index) => {
          if (item['account_id'] == selectItem['data'][0]['account_id']) {
            oldIndex = index;
          }
        })

        let status = '';
        let newItem = selectItem;
        if (selectItem['is_not_follow'] == 1) { // 恢复查看
          newItem.is_not_follow = 0;
          status = 2;
        } else { // 暂时不看
          newItem.is_not_follow = 1;
          if (newItem['is_top']) {
            newItem.is_top = 0;
          }
          status = 1;
        }

        if (selectItem['is_not_follow'] == 1) {
          this.studentListCard.push(this.studentListCard.splice(selectIndex , 1)[0]);
        } else {
          let current = this.studentListCard.splice(selectIndex, 1);
          this.studentListCard.splice(oldIndex, 0, current[0] );
        }
      },
      uniqeByKeys(array, keys) {
        var allArr = []
        for (var i = 0; i < array.length; i++) {
          var flag = true
          for (var j = 0; j < allArr.length; j++) {

            if (array[i].user_id === allArr[j].user_id && array[i].event === allArr[j].event && Math.abs(array[i].c_time - allArr[j].c_time) <= 1000 && !eventCheck) {
              flag = false
            }
          }
          let eventCheck = this.alarmLimitList.some((item)=>{
            return item == array[i].event
          })
          if (flag && eventCheck) {
            allArr.push(array[i])
          }
        }
        return allArr
      },
      // 显示排序的
      sortStudentData(data) {
        let newData = data.slice();
        newData.slice().sort((a,b) => b.offLineStatus - a.offLineStatus);
        let onlineStudent = [];
        let offLineStudent = [];
        newData.map(item => {
          if (!item['offLineStatus']) { // 在线
            let lastUserName = '';
            if (item['real_name']) {
              lastUserName = item['real_name'];
            } else {
              lastUserName = item.data[0].real_sname || item.data[0].nick
            }
            item['lastUserName'] = lastUserName;
            onlineStudent.push(item);
          } else {
            let lastUserName = '';
            if (item['real_name']) {
              lastUserName = item['real_name'];
            } else {
              lastUserName = item.data[0].real_sname || item.data[0].nick
            }
            item['lastUserName'] = lastUserName;
            offLineStudent.push(item);
          }
        })
        this.$emit('countStudent', onlineStudent);
        this.nowOnlineStudent['count'] = onlineStudent.length;
        if (!!sessionStorage.getItem('studentCardX')) {
          let studentCardXArr = JSON.parse(sessionStorage.getItem('studentCardX'));
          if (studentCardXArr.length == 0) {
            onlineStudent.map((item, index) => {
              let newItem = item;
              newItem['handleStatus'] = 2;
              this.$set(onlineStudent, index, newItem);
            })
            onlineStudent = onlineStudent.sort(function compareFunction(item1, item2) {
              return item1['real_name'].localeCompare(item2['real_name']);
            });
            offLineStudent = offLineStudent.sort(function compareFunction(item1, item2) {
              return item1['real_name'].localeCompare(item2['real_name']);
            });
            let allArr = onlineStudent.concat(offLineStudent);
            this.studentListCard = allArr;
            console.log(i18n.t('studentList.allStudent.631798-25'),allArr)
            return allArr;
          } else {
            let topStudentArr = [];
            let normalStudentArr = [];
            let bottomStudentArr = [];
            for (let i=0; i < onlineStudent.length; i++) {
              let dataItem = onlineStudent[i];
              let isExist = false;
              for (let j=0; j < studentCardXArr.length; j++ ) {
                let cardItem = studentCardXArr[j];
                if (dataItem['user_id'] == cardItem['user_id']) {
                  isExist = true;
                  if (cardItem['handleStatus'] == 1) { // 暂时不看他
                    dataItem['handleStatus'] = 1;
                    dataItem['handleTime'] = cardItem['handleTime'];
                    bottomStudentArr.push(dataItem);
                  } else if (cardItem['handleStatus'] == 3) { // 置顶
                    dataItem['handleStatus'] = 3;
                    dataItem['handleTime'] = cardItem['handleTime'];
                    topStudentArr.push(dataItem);
                  }
                  break;
                } else {
                  isExist = false;
                }
              }

              if (!isExist) {
                dataItem['handleStatus'] = 2;
                normalStudentArr.push(dataItem);
              }
            }
            topStudentArr = topStudentArr.sort(function compareFunction(item1, item2) {
              if (item1['real_name'] && item2['real_name']) {
                return item1['real_name'].localeCompare(item2['real_name']);
              }
            });
            normalStudentArr = normalStudentArr.sort(function compareFunction(item1, item2) {
              if (item1['real_name'] && item2['real_name']) {
                return item1['real_name'].localeCompare(item2['real_name']);
              }
            });
            bottomStudentArr = bottomStudentArr.sort(function compareFunction(item1, item2) {
              if (item1['real_name'] && item2['real_name']) {
                return item1['real_name'].localeCompare(item2['real_name']);
              }
            });
            let lastArr = topStudentArr.concat(normalStudentArr).concat(bottomStudentArr).concat(offLineStudent);
            console.log(i18n.t('studentList.allStudent.631798-26'),lastArr)
            this.studentListCard = lastArr;
            return lastArr
          }
        } else { // 说明之前没操作过置顶、不看他
          onlineStudent.map((item, index) => {
            let newItem = item;
            newItem['handleStatus'] = 2;
            this.$set(onlineStudent, index, newItem);
          })
          onlineStudent = onlineStudent.sort(function compareFunction(item1, item2) {
            if (item1['real_name'] && item2['real_name']) {
              return item1['real_name'].localeCompare(item2['real_name']);
            }
          });
          offLineStudent = offLineStudent.sort(function compareFunction(item1, item2) {
            if (item1['real_name'] && item2['real_name']) {
              return item1['real_name'].localeCompare(item2['real_name']);
            }
          });
          let lastArr = onlineStudent.concat(offLineStudent);
          this.studentListCard = lastArr;
          console.log(i18n.t('studentList.allStudent.631798-27'),lastArr)
          return lastArr
        }
      },
      queryAuthUserCount() {
        let subjectId = sessionStorage.getItem('subject_id')
        getAuthUserCount({subject_id: subjectId}).then(res => {
          if (res.code == 200) {
            this.authUserCount = res.data.count;
          }
        })
      },
      viewStudent (val, index, isLeft) {
        const cardtop = this.studentListCard.filter(card => card.user_id == (typeof val.user_id !== 'undefined' ? val.user_id + '' : val + ''))
        if (typeof index !== 'undefined' && cardtop.length > 0) {
          cardtop[0].index = index
        } else {
          cardtop[0].index = typeof val.index !== 'undefined' ? val.index : cardtop[0].index
        }
        this.cardTop = cardtop
        const vm = this
        const user_id = typeof val.user_id !== 'undefined' ? val.user_id + '' : val + ''
        console.log('user_id========='+user_id);
        const st = vm.studentListCard.filter(event_cell => event_cell.user_id == user_id)
        const qId = (typeof st[0].data[0].question_ids !== 'undefined' && st[0].data[0].question_ids instanceof Array) ? st[0].data[0].question_ids.join(',') : ''
        const topic_id = typeof st[0].data[0].topic_id !== 'undefined' ? st[0].data[0].topic_id : ''
        const subject_id = typeof st[0].data[0].subject_id !== 'undefined' ? st[0].data[0].subject_id : ''
        const school_id = typeof st[0].data[0].school_id !== 'undefined' ? st[0].data[0].school_id : ''
        const exam_else_info = typeof st[0].data[0].exam_else_info !== 'undefined' ? st[0].data[0].exam_else_info : ''
        const flow_id = typeof st[0].data[0].flow_id !== 'undefined' ? st[0].data[0].flow_id : ''
        const jupiter_stage = typeof st[0].data[0].stage !== 'undefined' ? st[0].data[0].stage : ''
        const course_id = typeof st[0].data[0].course_id !== 'undefined' ? st[0].data[0].course_id : ''
        const module_type = typeof st[0].data[0].module_type !== 'undefined' ? st[0].data[0].module_type : ''
        const module_name = typeof st[0].data[0].module_name !== 'undefined' ? st[0].data[0].module_name : ''
        const lesson_id = typeof st[0].data[0].lesson_id !== 'undefined' ? st[0].data[0].lesson_id : ' '
        const knowledge_code = typeof st[0].data[0].tag_code !== 'undefined' ? st[0].data[0].tag_code : ' '
        const question_bank_version = typeof st[0].data[0].question_bank_version !== 'undefined' ? st[0].data[0].question_bank_version : ''
        const question_vno = typeof st[0].data[0].question_vno !== 'undefined' ? st[0].data[0].question_vno : 0
        const account_id = val.data[0].account_id
        const stage = typeof st[0].data[0].stage !== 'undefined' ? st[0].data[0].stage : ''
        const q_forms = typeof st[0].data[0].q_forms !== 'undefined' ? st[0].data[0].q_forms : ''
        const learning_version = cardtop[0]['course_version'];

        let photoColor = '';
        if(typeof (index) === "undefined" && this.currentViewStudent.photoColor){
          photoColor = this.currentViewStudent.photoColor;
        }else{
          photoColor = vm.colors[typeof (index) !== "undefined" ? index % 8 : 0 % 8];
        }
        let today_course_answer = {};
        let today_course_knowledge = {};
        let today_course_learn = {};
        let module_answer = {};
        let module_learn = {};

        let getQuestionServerTime = '';

        if (st[0].data[0].event == 'GET_QUESTION') {
          getQuestionServerTime = st[0].data[0].server_time;
        }

        if (typeof (cardtop[0].today_course_answer) !='undefined') {
          today_course_answer = cardtop[0].today_course_answer;
        }

        if (typeof (cardtop[0].today_course_knowledge) !='undefined') {
          today_course_knowledge = cardtop[0].today_course_knowledge;
        }

        if (typeof (cardtop[0].today_course_learn) !='undefined') {
          today_course_learn = cardtop[0].today_course_learn;
        }

        if (typeof (cardtop[0].module_answer) !='undefined') {
          module_answer = cardtop[0].module_answer;
        }

        if (typeof (cardtop[0].module_learn) !='undefined') {
          module_learn = cardtop[0].module_learn;
        }

        let eventMessage = '';
        if (st[0].data[0].event) {
          eventMessage = st[0].data[0].event;
        }
        this.setMessageDisposeStatus(user_id);
        this.viewStudentDetail(val, index);
        this.$store.commit("SET_CURRENT_VIEW_STUDENT", {
          exam_else_info,
          school_id,
          user_id,
          course_id,
          topic_id,
          lesson_id,
          account_id,
          knowledge_code,
          stage,
          flow_id,
          subject_id,
          jupiter_stage,
          learning_version,
          question_bank_version,
          question_vno,
          photoColor,
          qId,
          msg: '',
          eventMessage,
          module_type,
          module_name,
          today_course_answer,
          today_course_knowledge,
          today_course_learn,
          module_answer,
          module_learn,
          getQuestionServerTime,
          q_forms
        });
        this.$store.commit('SET_CURRENT_USER_ID', user_id);
        if (this.pageStudentCard['msg'] == '') { // 说明缓存里面没有值
          let tempPageStudentCard = {
            val: val,
            index: typeof index !== 'undefined' ? index : -1,
            studentListCard: this.studentListCard,
            msg: 'detail'
          }
          this.$store.commit('SET_PAGE_STUDENT_CARD', tempPageStudentCard)
        }
        if (!isLeft && this.$route.path != "/supervise/detail") {
          this.$router.push({ path: '/supervise/detail', query: {} });
        }
      },
    },
    watch: {
      $route(to,from){
        if(to.path.includes('detail')){
          getMsgContorl.listToDetail()
        }else{
          getMsgContorl.detailToList()
        }
      },
      onlineStudentList: {
        handler: function(val) {
          if (val.length !== 0) {
            this.onlineStudentStatus = true
            this.addStudents()
          } else {
            this.onlineStudentStatus = false
          }
        },
        //deep: true
      },
      messageList: {
        handler: function(val, oldVal) {
          const vm = this
          this.messageList = val
          console.log(333333,val)
          vm.$store.commit('SET_MESSAGE_LIST', val);
          this.studentList.forEach((x, i) => {
            x.msgNum = vm.messageList.filter(function(item) {
              return (item.user_id == x.user_id && item.disposeStatus === false)
            }).length
          })
        },
        //deep: true
      },
      msgBusList1: {
        handler: function(val, oldVal) {
          // debugger
          const vm = this
          var newArr = []
          var hasSame = false
          for (let i = 0; i < val.length; i++) {
            if (newArr.length > 0) {
              // debugger
              for (var j = 0; j < newArr.length; j++) {
                if (val[i].user_id == newArr[j].user_id) {
                  newArr[j].data.push(val[i])
                  hasSame = true
                  break;
                }
              }
            }
            if (!hasSame) {
              var json = {}
              json.user_id = val[i].user_id
              json.nick = val[i].nick
              json.real_name = val[i].real_sname
              json.isJieru = val[i].isJieru
              json.initTime = val[i].initTime || new Date().getTime()
              json.today_course_answer = val[i].today_course_answer
              json.today_course_knowledge = val[i].today_course_knowledge
              json.today_course_learn = val[i].today_course_learn
              json.module_answer = val[i].module_answer
              json.module_learn = val[i].module_learn
              json.correct_notify = val[i].correct_notify
              json.course_version = val[i].course_version
              json.msgNum = val[i].msgNum || 0
              json.data = []
              json.data.push(val[i])
              newArr.push(json)
            }
            hasSame = false
          }
          if (!this.isFirst) {
            this.studentListCard = newArr
            this.isFirst = true
          }
          if (this.studentListCard.length !== newArr.length) {
            var arr3 = []
            for (const key in newArr) {
              var stra = newArr[key]
              var count = 0
              for (var j = 0; j < this.studentListCard.length; j++) {
                var strb = this.studentListCard[j]
                if (stra.user_id == strb.user_id) {
                  count++
                }
              }
              if (count === 0) { // 表示数组1的这个值没有重复的，放到arr3列表中
                arr3.push(stra)
              }
            }
            arr3.forEach(item => {
              this.studentListCard.push(item)
            })
            if (this.activePan != '0') {
              this.studentDetailMsg(this.activePan)
            }
          } else if (this.studentListCard.length == newArr.length) {
            for (let k = 0; k < this.studentListCard.length; k++) {
              for (let h = 0; h < newArr.length; h++) {
                if (this.studentListCard[k].user_id == newArr[h].user_id) {
                  if (newArr[h]['today_course_answer'] && !this.studentListCard[k]['today_course_answer']) {
                    this.studentListCard[k]['today_course_answer'] = newArr[h]['today_course_answer'];
                  }
                  if (newArr[h]['today_course_knowledge'] && !this.studentListCard[k]['today_course_knowledge']) {
                    this.studentListCard[k]['today_course_knowledge'] = newArr[h]['today_course_knowledge'];
                  }
                  if (newArr[h]['today_course_learn'] && !this.studentListCard[k]['today_course_learn']) {
                    this.studentListCard[k]['today_course_learn'] = newArr[h]['today_course_learn'];
                  }
                  if (newArr[h]['module_answer'] && !this.studentListCard[k]['module_answer']) {
                    this.studentListCard[k]['module_answer'] = newArr[h]['module_answer'];
                  }
                  if (newArr[h]['module_learn'] && !this.studentListCard[k]['module_learn']) {
                    this.studentListCard[k]['module_learn'] = newArr[h]['module_learn'];
                  }
                  this.studentListCard[k].data.unshift(newArr[h].data[0])
                }
              }
            }
          }
          if (this.activePan != '0') {
            this.studentDetailMsg(this.activePan)
          }
          this.$store.commit('SET_STUDENT_LIST_CARD_DATA', this.studentListCard)
          this.$store.commit('SET_LEFT_STUDENT_COUNT', this.studentListCard.length)
          this.$emit('countStudent', this.studentListCard);
        },
        //deep: true
      },
      msgBusList: {
        handler: function(val, oldVal) {
          // debugger
          const vm = this
          var newArr = []
          var json = {
            ...val[0]
          }
              json.user_id = val[0].user_id
              json.nick = val[0].nick
              json.real_name = val[0].real_sname
              json.isJieru = val[0].isJieru
              json.initTime = val[0].initTime || new Date().getTime()
              json.today_course_answer = val[0].today_course_answer
              json.today_course_knowledge = val[0].today_course_knowledge
              json.today_course_learn = val[0].today_course_learn
              json.module_answer = val[0].module_answer
              json.module_learn = val[0].module_learn
              json.correct_notify = val[0].correct_notify
              json.course_version = val[0].course_version
              json.msgNum = val[0].msgNum || 0
              json.data = [val[0]]
              //json.data.push(val[0])
              newArr.push(json)

          console.log(val[0].event,newArr[0],99999977779)
          if (!this.isFirst) {
            this.studentListCard = newArr
            this.isFirst = true
            this.sortStudentData(this.studentListCard)
          }else{
            let targetArr = this.studentListCard.filter(item=>item.user_id == newArr[0].user_id)
            if(!targetArr.length){
              this.studentListCard.push(newArr[0])
              if (this.activePan != '0') {
                this.studentDetailMsg(this.activePan)
              }
              this.sortStudentData(this.studentListCard)
            }
          }
          console.log(this.studentListCard,999999,'this.studentListCard')

          if (true) {
            let tempStudentListCard = JSON.parse(JSON.stringify(this.studentListCard))
            for (let k = 0; k < tempStudentListCard.length; k++) {
              //for (let h = 0; h < newArr.length; h++) {
                if (tempStudentListCard[k].user_id == newArr[0].user_id) {
                  let target = tempStudentListCard[k];
                  if (newArr[0]['today_course_answer'] && !target['today_course_answer']) {
                    target['today_course_answer'] = newArr[0]['today_course_answer'];
                  }
                  if (newArr[0]['today_course_knowledge'] && !target['today_course_knowledge']) {
                    target['today_course_knowledge'] = newArr[0]['today_course_knowledge'];
                  }
                  if (newArr[0]['today_course_learn'] && !target['today_course_learn']) {
                    target['today_course_learn'] = newArr[0]['today_course_learn'];
                  }
                  if (newArr[0]['module_answer'] && !target['module_answer']) {
                    target['module_answer'] = newArr[0]['module_answer'];
                  }
                  if (newArr[0]['module_learn'] && !target['module_learn']) {
                    target['module_learn'] = newArr[0]['module_learn'];
                  }
                  let dataList = target.data;
                  if(this.alarmLimitList.indexOf(val[0].event) == -1){
                    dataList = dataList.filter(item=>this.alarmLimitList.includes(item.event))
                    dataList.unshift(newArr[0].data[0])
                  }else if(!JSON.stringify(dataList).includes(val[0].event_id) && (val[0].c_time ? val[0].c_time > new Date(new Date().toLocaleDateString()).getTime() : true)){
                    //报警信息过滤重复数据和昨天的数据
                    dataList.splice(1,0,newArr[0].data[0])
                  }
                  target.data = dataList;
                  //this.tempStudentListCard[k] = target;
                  //this.studentListCard[k] = target
                  this.$set(this.studentListCard,k,target)
                  //报警加入
                  if(this.currentViewStudent.user_id == newArr[0].user_id){
                    this.messageList = dataList
                    Bus.$emit('messageList', this.messageList)
                  }
                  console.log(9999999,i18n.t('studentList.allStudent.631798-28'),this.studentListCard[k].data,this.alarmLimitList.indexOf(newArr[0].event) == -1)
                  break;
                  //this.studentListCard[k].data.unshift(newArr[h].data[0])
                }
              //}
            }
          }
          if (this.activePan != '0') {
            this.studentDetailMsg(this.activePan)
          }
          if((newArr[0].event == 'LOGIN' || newArr[0].event == 'RELOGIN') && this.destroyRoomObj[newArr[0].account_id]){
            vm.destroyRoom(this.destroyRoomObj[newArr[0].account_id],newArr[0])
            vm.destroyRoomObj[newArr[0].account_id] = ''
          }
          //console.log(this.studentListCard,9999997777)
          this.$store.commit('SET_STUDENT_LIST_CARD_DATA', this.studentListCard)
          this.$store.commit('SET_LEFT_STUDENT_COUNT', this.studentListCard.length)
          //this.$emit('countStudent', this.studentListCard);
          console.log(this.studentListCard,this.messageList,this.onlineStudentList,4444444)
        },
        //deep: true
      },
      studentList: function(newArr, oldArr){
        newArr.forEach((x, i) => {
          if (x.nick !== i18n.t('studentList.allStudent.631798-13') && this.userList.indexOf(x.user_id) == -1) {
            this.userList.push(x.user_id)
          }
        })
      },
      currentViewStudent: function(newVal, oldVal){
        if(oldVal.user_id != newVal.user_id){
          for(let m = 0; m < this.studentListCard.length; m++){
            if (this.studentListCard[m].user_id == newVal.user_id) {
              this.messageList = this.studentListCard[m].data
              Bus.$emit('messageList', this.messageList)
              break
            }
          }
        }
      },
      studentListCard: function(newArr, oldArr) {
        if (newArr.length > 0) {
          if (this.currentViewStudent['user_id'] == '' && this.$route.path == '/supervise/detail') { // 说明存储在store中的当前学生丢失了，重新去查找
            let index = '';
            let selectItem = '';
            let allCount = 0;
            for (let i= 0; i < newArr.length; i++) {
              let student = newArr[i];
              if (sessionStorage.getItem('user_id') == student['user_id']) {
                index = i;
                selectItem = student;
              }
              allCount++;
            }
            if (index == '' && newArr.length > 0) {
              index = 0;
              selectItem = newArr[0];
            }
            this.viewStudent(selectItem, index, 'left');
            //this.onlineStudentCount = allCount;
            //this.nowOnlineStudent = {};
            //this.nowOnlineStudent['count'] = allCount;
          }
        }
      },
    },
  }
</script>

<style scoped lang="scss">
  .left-list {
    .module-header-title {
      margin: 14px 0 17px 18px;
    }
    .sub {
      margin: 11px 0 0 20px;
      font-size: 14px;
    }
  }
  .no-people {
    padding-bottom: 204px;
    .text {
      font-size: 16px;
      line-height: 24px;
      color: #444b65;
      text-align: center;
      opacity: .8;
    }
  }
  .left-student-list {
    margin-bottom: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/views/studentList/allStudent.vue